module.exports = function() {
  return new Worker(__webpack_public_path__ + "adf79975568230e95f84.worker.js");
};